<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="Antropometria"
        type="box"
    >
        <rkm-row>
            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('peso')">
                <rkm-form-input
                    :validations="validations.peso"
                    @change.native="handlePesoChange"
                    @input="handlePesoInput"
                    label="Peso"
                    placeholder="000.000"
                    v-model="data.model.antropometria.peso"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            kg
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('altura')">
                <rkm-form-input
                    :validations="validations.altura"
                    @input="value => handleDecimalInput(value, 'altura')"
                    @change.native="handleAlturaChange"
                    label="Altura"
                    placeholder="000.0"
                    v-mask="masks.altura"
                    v-model="data.model.antropometria.altura"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('imc')">
                <rkm-form-input
                    disabled
                    label="IMC"
                    v-model="data.model.antropometria.imc.imc"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            {{data.model.antropometria.imc.classificacao}}
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('perimetroCefalico')">
                <rkm-form-input
                    :validations="validations.perimetroCefalico"
                    @input="value => handleDecimalInput(value, 'perimetroCefalico')"
                    @change.native="handlePerimetroCefalicoChange"
                    label="Perímetro cefálico"
                    placeholder="000.0"
                    v-mask="masks.perimetroCefalico"
                    v-model="data.model.antropometria.perimetroCefalico"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('circunferenciaAbdominal')">
                <rkm-form-input
                    :validations="validations.circunferenciaAbdominal"
                    @input="value => handleDecimalInput(value, 'circunferenciaAbdominal')"
                    @change.native="handleCircunferenciaAbdominalChange"
                    label="Circunferência abdominal"
                    placeholder="000.0"
                    v-mask="masks.circunferenciaAbdominal"
                    v-model="data.model.antropometria.circunferenciaAbdominal"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>

            <rkm-col :cols="hiddenFields.length > 2 ? '4' : '3'" v-show="!hiddenFields.includes('perimetroPanturrilha')">
                <rkm-form-input
                    :validations="validations.perimetroPanturrilha"
                    @input="value => handleDecimalInput(value, 'perimetroPanturrilha')"
                    @change.native="handlePerimetroPanturrilhaChange"
                    label="Perímetro da panturrilha"
                    placeholder="00.0"
                    v-mask="masks.perimetroPanturrilha"
                    v-model="data.model.antropometria.perimetroPanturrilha"
                >
                    <rkm-input-group-append slot="append">
                        <rkm-input-group-text>
                            cm
                        </rkm-input-group-text>
                    </rkm-input-group-append>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row v-show="!hiddenFields.includes('comprimentoPeDireito')">
            <rkm-col cols="12">

                <rkm-area
                    background-color="primary"
                    title="Podometria"
                    no-margin-top
                    type="fieldset"
                    class="pt-0 mt-0"
                >

                    <rkm-area
                        background-color="primary"
                        title="Pé direito"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col cols="4">
                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe o comprimento do pé em centímetros, da extremidade do calcanhar até a ponta do maior dedo.'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.comprimentoPe"
                                    @input="value => handleDecimalInput(value, 'comprimentoPeDireito')"
                                    label="Comprimento do pé"
                                    placeholder="00.0"
                                    v-mask="masks.comprimentoPe"
                                    v-model="data.model.antropometria.comprimentoPeDireito"

                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe a largura máxima do pé em centímetros, geralmente medida na região do antepé.'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.larguraPe"
                                    @input="value => handleDecimalInput(value, 'larguraPeDireito')"
                                    label="Largura do pé"
                                    placeholder="00.0"
                                    v-mask="masks.larguraPe"
                                    v-model="data.model.antropometria.larguraPeDireito"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe a circunferência do pé em centímetros, quando for realizada a medição (ex.: antepé ou mediopé).'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.circunferenciaPe"
                                    @input="value => handleDecimalInput(value, 'circunferenciaPeDireito')"
                                    label="Circunferência do Pé"
                                    placeholder="00.0"
                                    v-mask="masks.circunferenciaPe"
                                    v-model="data.model.antropometria.circunferenciaPeDireito"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        background-color="primary"
                        title="Pé esquerdo"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col cols="4">

                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe o comprimento do pé em centímetros, da extremidade do calcanhar até a ponta do maior dedo.'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.comprimentoPe"
                                    @input="value => handleDecimalInput(value, 'comprimentoPeEsquerdo')"
                                    label="Comprimento do pé"
                                    placeholder="00.0"
                                    v-mask="masks.comprimentoPe"
                                    v-model="data.model.antropometria.comprimentoPeEsquerdo"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>

                            <rkm-col cols="4">

                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe a largura máxima do pé em centímetros, geralmente medida na região do antepé.'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.larguraPe"
                                    @input="value => handleDecimalInput(value, 'larguraPeEsquerdo')"
                                    label="Largura do pé"
                                    placeholder="00.0"
                                    v-mask="masks.larguraPe"
                                    v-model="data.model.antropometria.larguraPeEsquerdo"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>

                            <rkm-col cols="4">

                                <rkm-icon
                                    icon="info"
                                    color="secondary"
                                    class="infor d-flex pa-2 float-right"
                                    small
                                    v-rkm-popover.hover.left="{
                                        html:true,
                                        content: 'Informe a circunferência do pé em centímetros, quando for realizada a medição (ex.: antepé ou mediopé).'
                                    }"
                                />

                                <rkm-form-input
                                    :validations="validations.circunferenciaPe"
                                    @input="value => handleDecimalInput(value, 'circunferenciaPeEsquerdo')"
                                    label="Circunferência do Pé"
                                    placeholder="00.0"
                                    v-mask="masks.circunferenciaPe"
                                    v-model="data.model.antropometria.circunferenciaPeEsquerdo"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            cm
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxAntropometria
                    v-if="data.form.antropometria"
                    :data="data.form.antropometria"
                    title="Antropometria realizada na mesma data, durante o acolhimento."
                />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Enums.
import unidadeMedida from '@/enums/cadastro/unidadeMedida'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

import BoxAntropometria from '@/components/ambulatorio/atendimento/components/historico/components/antropometria/Index'

export default {
    components: {
        BoxAntropometria,
    },
    computed: {
        validations() {
            return {
                peso: {
                    min_value: 0.5,
                    max_value: 500,
                    max: 7,
                    required: this.required
                },
                altura: {
                    min_value: 20.0,
                    max_value: 250.0,
                    required: this.required
                },
                perimetroCefalico: {
                    min_value: 10,
                    max_value: 200,
                },
                circunferenciaAbdominal: {
                    max_value: 999,
                    required: this.required
                },
                perimetroPanturrilha: {
                    min_value: 10,
                    max_value: 99,
                },
                comprimentoPe: {
                    min_value: 10,
                    max_value: 40,
                },
                larguraPe: {
                    min_value: 5,
                    max_value: 20,
                },
                circunferenciaPe: {
                    min_value: 10,
                    max_value: 50,
                },
            }
        },
    },
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        enums: {unidadeMedida},
        masks: {
            altura: '###.#',
            circunferenciaAbdominal: '###.#',
            perimetroCefalico: '###.#',
            perimetroPanturrilha: '##.#',
            comprimentoPe: '##.#',
            larguraPe: '##.#',
            circunferenciaPe: '##.#',
            peso: '###.###',
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handlePesoChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('pesoChange', event.target.value)
                this.calcularIMC()
            }
        },
        handleAlturaChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('alturaChange', event.target.value)

                this.calcularIMC()
            }
        },
        handlePerimetroCefalicoChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('perimetroCefalicoChange', event.target.value)
            }
        },
        handleCircunferenciaAbdominalChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('circunferenciaAbdominalChange', event.target.value)
            }
        },
        handlePerimetroPanturrilhaChange(event) {
            if (!event.target.classList.contains('is-invalid')) {
                this.$emit('perimetroPanturrilhaChange', event.target.value)
            }
        },
        calcularIMC() {
            if (!this.data.model.antropometria.peso || !this.data.model.antropometria.altura) {
                this.data.model.antropometria.imc.imc = null
                this.data.model.antropometria.imc.classificacao = null
            } else {
                this.setLoading()

                const request = {
                    unidade_medida_massa_id: this.enums.unidadeMedida.QUILOGRAMAS,
                    massa: parseFloat(this.data.model.antropometria.peso.replace(',', '.')),
                    unidade_medida_altura_id: this.enums.unidadeMedida.CENTIMETROS,
                    altura: this.data.model.antropometria.altura,
                }
                

                this.repositories.geral.calcularIMC(request)
                    .then(response => {
                        this.data.model.antropometria.imc = response.data
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        handleDecimalInput(value, field) {
            const digits = String(value).replace(/\D/g, '')

            if (!digits) {
                this.data.model.antropometria[field] = ''
                return
            }

            if (digits.length === 1) {
                this.data.model.antropometria[field] = digits
                return
            }

            this.data.model.antropometria[field] =
                `${digits.slice(0, -1)}.${digits.slice(-1)}`
        },

        handlePesoInput(e) {

            let value = e.replace(/\D/g, '')

            if (!value) {
                this.data.model.antropometria.peso = ''
                return
            }

            if (value.length === 1) {
                this.data.model.antropometria.peso = value
            } else if (value.length === 2) {
                this.data.model.antropometria.peso = value[0] + '.' + value[1]
            } else if (value.length === 3) {
                this.data.model.antropometria.peso = value[0] + '.' + value.slice(1)
            } else if (value.length === 4) {
                this.data.model.antropometria.peso = value[0] + '.' + value.slice(1)
            } else if (value.length === 5) {
                this.data.model.antropometria.peso = value.slice(0, 2) + '.' + value.slice(2)
            } else {
                this.data.model.antropometria.peso = value.slice(0, 3) + '.' + value.slice(3, 6)
            }
        },
    },
    mixins: [error, repository, stringCase],
    props: {
        closed: {type: Boolean, default: false},
        required: {type: Boolean, default: false},
        data: {type: Object, required: true},
        hiddenFields: {type: Array, default: () => []}
    },
    watch: {
        'data.model.antropometria.peso': {
            handler() {
                this.calcularIMC()
            }
        },

        'data.model.antropometria.altura': {
            handler() {
                this.calcularIMC()
            }
        }
    },
}
</script>

<style scoped>
.infor {
    color: #acacac;
    height: 15px;
    width: 15px !important;
    position: absolute;
    right: 8px;
    top: 5px;
    border-radius: 31px;
    padding: 3px;
    border: 1px solid #c2c2c2;
}
</style>